// @flow

import {
  BRANCH,
  POINTS_BRANCH,
  GRIDS_BRANCH,
} from './constants'

export default {
  [BRANCH]: {},
  [POINTS_BRANCH]: {},
  [GRIDS_BRANCH]: {},
}
